import React from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const LabEquipment = () => {
  const labEquipment = [
    {
      itemCode: "LAB001",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB002",
      item: "Funnel",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB003",
      item: "Salpher di oxide",
      orderSize: "250 gm",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB004",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB005",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB006",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB007",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
    {
      itemCode: "LAB008",
      item: "Tube",
      orderSize: "10 pcs",
      needOn: "02 Oct, 2025",
      reporter: "Samiul Ittefak",
      amount: 18000,
    },
  ];

  const labTableHeaders = [
    { key: "item", label: "Items" },
    { key: "orderSize", label: "Order size" },
    { key: "needOn", label: "Need on" },
    { key: "reporter", label: "Reported by" },
  ];

  const labHistoryData = [
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "Tube", routeNo: "10 pcs", amount: 18000 },
        { vehicleNo: "Funnel", routeNo: "14 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "Tube", routeNo: "10 pcs", amount: 18000 },
        { vehicleNo: "Funnel", routeNo: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: null,
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "Tube", routeNo: "10 pcs", amount: 18000 },
        { vehicleNo: "Funnel", routeNo: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: null,
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "Tube", routeNo: "10 pcs", amount: 18000 },
        { vehicleNo: "Funnel", routeNo: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      vehicles: [
        { vehicleNo: "Tube", routeNo: "10 pcs", amount: 18000 },
        { vehicleNo: "Funnel", routeNo: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: null,
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
  ];

  const columns = [
    {
      label: "Receipt id/Time",
      key: "receiptId",
      render: (row) => (
        <>
          {row.receiptId}
          <br />
          <span style={{ color: "var(--orangeColor)", fontSize: "small" }}>
            {row.time}
          </span>
        </>
      ),
    },
    {
      label: "Items",
      key: "vehicleNo",
      render: (row) =>
        row.vehicles.map((v, i) => <div key={i}>{v.vehicleNo}</div>),
    },
    {
      label: "Order size",
      key: "routeNo",
      render: (row) =>
        row.vehicles.map((v, i) => <div key={i}>{v.routeNo}</div>),
    },
    {
      label: "Amount (INR)",
      key: "amount",
      render: (row) => (
        <>
          {row.vehicles.map((v, i) => (
            <div key={i}>₹ {Number(v.amount).toLocaleString("en-IN")}</div>
          ))}
          <div style={{ borderTop: "1px solid black", marginTop: "4px" }}>
            Total:{" "}
            <span style={{ color: "var(--blueColor1)" }}>
              ₹ {Number(row.totalAmount).toLocaleString("en-IN")}
            </span>
          </div>
        </>
      ),
    },
    {
      label: "Paid amount (INR)",
      key: "paidAmount",
      render: (row) => (
        <>
          ₹ {Number(row.paidAmount).toLocaleString("en-IN")}
          <br />
          <span style={{ color: "var(--deepGreen3)", fontSize: "small" }}>
            {row.paymentMethod}
          </span>
        </>
      ),
    },
    {
      label: "Vendor details",
      key: "vendor",
      render: (row) => (
        <>
          {row.vendor.name}
          <br />
          Ph:{" "}
          <span style={{ color: "var(--blueColor1)" }}>{row.vendor.phone}</span>
        </>
      ),
    },
    {
      label: "Confirmed by",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--deepGreen3)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "receipts",
      render: (row) => (
        <>
          <span
            style={{
              color: "var(--blueColor1)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            Receipt <BsBoxArrowRight />
          </span>
          <br />
          <button
            className="action-pay-btn"
            style={{
              backgroundColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
              borderColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
            }}
          >
            {row.paidAmount < row.totalAmount ? "Pay due" : "All paid"}
          </button>
        </>
      ),
    },
  ];

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];
  const _this = {
    labEquipment,
    labTableHeaders,
    labHistoryData,
    columns,
    confirmedByOptions,
    paymentModes,
  };
  return <Body {..._this} />;
};

export default LabEquipment;
